import React from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Button from '../../Button';
import { formatAmount } from '../../../utils/appointments/formatAmount';
import { appointmentDetailsActions } from '../../../redux/healthboard/appointment-details';
import styles from './styles.styl';

function PaymentGate({ appointmentId, copay }) {
  const dispatch = useDispatch();

  const handlePay = () => {
    dispatch(
      appointmentDetailsActions.startPaymentProcess({ id: appointmentId }),
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <FormattedMessage id="virtualVisit.paymentGate.title" />
      </div>
      <div className={styles.description}>
        <FormattedMessage id="virtualVisit.paymentGate.description" />
      </div>
      <div className={styles.cost}>
        <span className={styles.costLabel}>
          <FormattedMessage id="virtualVisit.paymentGate.yourCost" />
        </span>
        <span className={styles.costAmount}>
          <FormattedMessage
            id="virtualVisit.paymentGate.total"
            values={{ amount: `$${formatAmount(copay)}` }}
          />
        </span>
      </div>
      <Button color="primary" raised onClick={handlePay}>
        <FormattedMessage id="virtualVisit.paymentGate.pay" />
      </Button>
    </div>
  );
}

PaymentGate.propTypes = {
  appointmentId: PropTypes.number,
  copay: PropTypes.number,
};

export default PaymentGate;



// WEBPACK FOOTER //
// ./src/components/VirtualRoom/PaymentGate/index.jsx